import React from 'react';
import { EXTENDED_HOLIDAYS_MESSAGE } from '../../constants/extendedHolidaysMessage';
import { ReturnPolicy } from '../../generated/types/globalTypes';
import { ReturnPolicyFinalSaleCopy } from './ReturnPolicyFinalSaleCopy';
import { ReturnPolicyCopyReturnable } from './ReturnPolicyCopyReturnable';
import { ShortReturnPolicyCopyApproach } from './ShortReturnPolicyCopy';

interface Props {
  returnPolicy: ReturnPolicy;
  promoCodeApplied?: boolean;
  approach?: ShortReturnPolicyCopyApproach;
  highlightDaysNumber?: boolean;
}

export const ReturnPolicyCopy: React.FC<Props> = ({
  approach,
  promoCodeApplied = false,
  returnPolicy,
  highlightDaysNumber = false
}) => {
  if (returnPolicy === ReturnPolicy.extended_holidays) {
    return <>{EXTENDED_HOLIDAYS_MESSAGE}</>;
  }

  if (returnPolicy === ReturnPolicy.final_sale) {
    return <ReturnPolicyFinalSaleCopy approach={approach} />;
  }

  return (
    <ReturnPolicyCopyReturnable
      approach={approach}
      returnPolicy={returnPolicy}
      promoCodeApplied={promoCodeApplied}
      highlightDaysNumber={highlightDaysNumber}
    />
  );
};
